/**
 * REST client for NPS (Net Promoter Score).
 */

import { httpRequest } from "@/lib/axios";

export type NpsResponse = {
  id: string;
  patient_id: string;
  scheduling_id: string;
  score: number;
  feedback: string | null;
  sent_at: string;
  responded_at: string | null;
  channel: "whatsapp" | "email";
  patient?: { id: string; name: string; phone: string };
  created_at: string;
};

export type NpsDashboard = {
  average_score: number;
  promoters: number;
  passives: number;
  detractors: number;
  nps_score: number;
  total_responses: number;
  response_rate: number;
  recent_responses: NpsResponse[];
};

/**
 * P-07: propagates its failure. A null return meant both "the clinic has no
 * answers yet" and "the read did not happen", and the page hid the panel in
 * both cases (PRODUCT_GOVERNANCE rule 8).
 */
export async function fetchNpsDashboard(): Promise<NpsDashboard | null> {
  const { data } = await httpRequest.get("/nps/dashboard");
  return data ?? null;
}

export async function fetchNpsResponses(page = 1): Promise<{ data: NpsResponse[]; total: number }> {
  try {
    const { data } = await httpRequest.get(`/nps?page=${page}`);
    return data;
  } catch {
    return { data: [], total: 0 };
  }
}

export async function sendNpsSurvey(payload: {
  patient_id: string;
  scheduling_id: string;
  channel?: string;
}): Promise<NpsResponse | null> {
  try {
    const { data } = await httpRequest.post("/nps", payload);
    return data;
  } catch {
    return null;
  }
}
